module.exports = __webpack_public_path__ + "static/funds-bg-1bceee63f1933088eb08cb46dc08e144.png";